import swal from 'sweetalert2';
import capitalize from 'lodash/capitalize';

export default {
    defaultSuccess: {
        type: 'success'
    },
    defaultError: {
        type: 'error'
    },
    defaultWarning: {
        type: 'warning'
    },
    success(subject, msg) {
        let data = this.defaultSuccess;
        data.title = capitalize(subject);
        data.text = msg;
        return swal.fire(data);
    },
    error(subject, htmlMessage) {
        let data = this.defaultError;
        data.title = capitalize(subject);
        if (htmlMessage) {
            data.html = htmlMessage;
        }
        return swal.fire(data);
    },
    warning(subject, htmlMessage) {
        let data = this.defaultWarning;
        data.title = capitalize(subject);
        data.html = htmlMessage;

        return swal.fire(data);
    },
    plainTextError(subject, message) {
        return this.error(subject, this.wrapErrorList([message]));
    },
    plainTextSimpleError(message) {
        return this.error(message);
    },
    plainTextWarning(subject, message) {
        return this.warning(subject, this.wrapErrorList([message]));
    },
    plainTextSuccess(subject, message) {
        return this.success(subject, message);
    },
    plainTextErrorFromArray(subject, messages) {
        return this.error(subject, this.wrapErrorList(messages));
    },
    message() {

    },
    fromResponse(response) {
        console.log('deprecated, use errorFromResponse and successFromResponse');
        if (response.status !== 200) {
            if (Array.isArray(response.body.errors)) {
                let ul = this.wrapErrorList(response.body.errors);
                return this.error(response.body.message, ul);
            }
            return this.plainTextError('Järjestelmävirhe', 'Nyt jotain meni pieleen, yritäthän hetken kuluttua uudelleen');
        }
        return this.success(response.body.title, response.body.message);
    },
    errorFromResponse(response) {
        if (Array.isArray(response.body.errors)) {
            let ul = this.wrapErrorList(response.body.errors);
            return this.error(response.body.message, ul);
        }
        return this.plainTextError('Järjestelmävirhe', 'Nyt jotain meni pieleen, yritäthän hetken kuluttua uudelleen');
    },
    successFromResponse(response) {
        return this.success(response.body.title, response.body.message);
    },
    wrapErrorList(errors) {
        if (Array.isArray(errors)) {
            let ul = document.createElement('ul');
            ul.className = 'errorList';
            errors.forEach((item) => {
                let li = document.createElement('li');
                let text = document.createTextNode(item);
                li.appendChild(text);
                ul.appendChild(li);
            });
            return ul;
        }
        return '';
    },
    modal(props) {
        return swal.fire(props);
    }
};
